import React from 'react'
import { DeleteForever, Edit } from '@mui/icons-material'
import { isCPF } from 'brazilian-values'
import { formatToCNPJ, formatToCPF } from 'utils/masks'
import CustomIconButton from "../../CustomTooltipIconButton"

const buildActions = (value) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
      <CustomIconButton
        onClick={value.edit}
        tooltipTitle="Editar registro"
        icon={<Edit />}
      />

      <CustomIconButton
        onClick={value.remove}
        tooltipTitle="Remover registro"
        icon={<DeleteForever />}
      />
    </div>
  )
}

export const columns = [
  {
    name: 'cpf_cnpj',
    label: 'CPF/CNPJ',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        return isCPF(value) ? formatToCPF(value) : formatToCNPJ(value)
      },
    },
  },
  {
    name: 'flag_denylist',
    label: 'Presente na "deny list"',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        return value ? 'Sim' : 'Não'
      },
    },
  },
  {
    name: 'flag_attention',
    label: 'Presente na "attention list"',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        return value ? 'Sim' : 'Não'
      },
    },
  },
  {
    name: 'actions',
    label: 'Ações',
    options: {
      filter: false,
      sort: false,
      download: false,
      customBodyRender: (value) => buildActions(value),
      setCellProps: () => ({
        style: {
          width: '100px',
        },
      }),
    },
  },
]
